export const DateFormat = data => {
  const date = new Date(data)
  if (isNaN(date?.getTime())) {
    return '-'
  }
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' }
  return date?.toLocaleDateString('en-GB', options)
}
export const arrayIntoString = data => {
  let dataString = data ? data?.join(',') : data
  return dataString
}

export const degreeListConvertion = listOfDegree => {
  return (
    listOfDegree?.length &&
    listOfDegree?.map(item => {
      return {
        title: item?.name,
        value: item?.id,
        children: item?.stream?.map(data => {
          return {
            title: data?.name,
            value: data?.degreeStreamMapId,
          }
        }),
      }
    })
  )
}

export const RefinedData = data => {
  if (Array?.isArray(data)) {
    const firstThreeElements = data.slice(0, 3)
    let name = firstThreeElements?.map(item => item?.name)
    return name?.join(', ') || '-'
  } else if (typeof data === 'string' || typeof data === 'number') {
    return data?.toString() ? data : '-'
  } else {
    return '-'
  }
}

export const degreeListConvertionOriginal = ({
  listOfDegree,
  parentNameParam = 'name',
  parentValueParam = 'id',
  pathName = 'degreeStreamMap',
  selectedIds = [],
  isEditActiveRole = false,
}) => {
  return (
    listOfDegree?.length &&
    listOfDegree?.map(item => {
      return {
        key: item[parentValueParam],
        title: item[parentNameParam],
        value: item[parentValueParam],
        disabled: isEditActiveRole
          ? selectedIds?.includes(item[parentValueParam])
          : false,
        children: item[pathName]?.map(data => {
          return {
            key: data[parentValueParam],
            checked: false,
            title:
              pathName === 'streams'
                ? data?.name
                : item?.shortForm
                ? `${item?.shortForm} - ${data?.stream?.name}`
                : data?.stream?.name,
            value: data[parentValueParam],
            streamData: {
              id: data[parentValueParam],
              streamId: data?.stream?.id,
            },
            disabled: isEditActiveRole
              ? selectedIds?.includes(data[parentValueParam])
              : false,
          }
        }),
      }
    })
  )
}

export const degreeListConvertionPart = ({
  listOfDegree,
  parentNameParam = 'degree',
  parentValueParam = 'degree_id',
  childValueParam = 'degreedepartmentid',
  childNameParam = 'department',
  pathName = 'department',
  selectedIds = [],
  isEditActiveRole = false,
}) => {
  return (
    listOfDegree?.length &&
    listOfDegree?.map(item => {
      return {
        key: item[parentValueParam],
        title:
          (item['short_form'] ? item['short_form'] : '') +
          ' - ' +
          item[parentNameParam],
        value: item[parentValueParam],
        disabled: isEditActiveRole
          ? selectedIds?.includes(item[parentValueParam])
          : false,
        children: item[pathName]?.map(data => {
          return {
            key: data[childValueParam],
            checked: false,
            title: data[childNameParam],

            value: data[childValueParam],
            streamData: {
              id: data[childValueParam],
              streamId: data[childValueParam],
            },
            disabled: isEditActiveRole
              ? selectedIds?.includes(data[parentValueParam])
              : false,
          }
        }),
      }
    })
  )
}
export const serialNo = (index, previousPage, currentPage, loadingRole) => {
  if (loadingRole)
    return previousPage > 0
      ? index + 1 + previousPage * 10 - 10
      : index + 1 + 1 * 10 - 10
  else return index + 1 + currentPage * 10 - 10
}
